/* eslint-disable react/prop-types */
import React from 'react';
import MegaMenuMobileLinkBlockHeader from './MegaMenuMobileLinkBlockHeader';
import { MegaMenuCard } from './MegaMenuCard.tsx';

const MegaMenuMobileColumnItemHeader = ({ item, onTitleClick }) => {
  if (item.contentType[1] === 'MegaMenuLinksBlock') {
    return (
      <MegaMenuMobileLinkBlockHeader linkBlock={item} onClick={onTitleClick} />
    );
  }

  if (item.contentType[1] === 'MegaMenuCard') {
    return (
      <MegaMenuCard
        title={item.title?.value}
        description={item.description?.value}
        imageSrc={item.image?.value?.url}
        url={item.url?.value}
      />
    );
  }

  return null;
};

export default MegaMenuMobileColumnItemHeader;
